module.exports = "/next-static/_next/static/images/easyGuestManagement-5438aa563aa3c3445b988962f4c158c0.png";